import type { PortSocialVideo } from "./port-home-content";

export const portSocialProfile = {
  username: "@nauticaalvarez",
  displayName: "Náutica Álvarez",
  avatar: "/images/social/nauticaalvarez/avatar.jpg",
};

export const portSocialFallback: PortSocialVideo[] = [
  {
    id: "Dc-kGyqCmi4",
    title: "Puesta a punto",
    caption: "Mantenimiento para navegar con total tranquilidad.",
    src: "/images/social/nauticaalvarez/Dc-kGyqCmi4.jpg",
    poster: null,
    instagramUrl: "https://www.instagram.com/nauticaalvarez/p/Dc-kGyqCmi4/",
    kind: "image",
  },
  {
    id: "DbKyraeiudn",
    title: "Revisión Volvo Penta D4",
    caption: "Una nueva jornada de revisión en el taller.",
    src: "/images/social/nauticaalvarez/DbKyraeiudn.jpg",
    poster: null,
    instagramUrl: "https://www.instagram.com/nauticaalvarez/p/DbKyraeiudn/",
    kind: "image",
  },
  {
    id: "Da2kfvsihCw",
    title: "Sabor 680 lista para navegar",
    caption: "Puesta a punto completa antes de volver al agua.",
    src: "/images/social/nauticaalvarez/Da2kfvsihCw.jpg",
    poster: null,
    instagramUrl: "https://www.instagram.com/nauticaalvarez/p/Da2kfvsihCw/",
    kind: "image",
  },
  {
    id: "DalgSKoqp_i",
    title: "Evinrude 175 HP",
    caption: "Cambio de retenes y diábolo.",
    src: "/images/social/nauticaalvarez/DalgSKoqp_i.jpg",
    poster: null,
    instagramUrl: "https://www.instagram.com/nauticaalvarez/reel/DalgSKoqp_i/",
    kind: "image",
  },
  {
    id: "DalQ3p3qnmU",
    title: "Suzuki DF200",
    caption: "Día de revisión y mantenimiento.",
    src: "/images/social/nauticaalvarez/DalQ3p3qnmU.jpg",
    poster: null,
    instagramUrl: "https://www.instagram.com/nauticaalvarez/reel/DalQ3p3qnmU/",
    kind: "image",
  },
  {
    id: "DalQhmcChsx",
    title: "Shiren lista para volver al agua",
    caption: "Puesta a punto de una embarcación equipada con Suzuki 200 CV.",
    src: "/images/social/nauticaalvarez/DalQhmcChsx.jpg",
    poster: null,
    instagramUrl: "https://www.instagram.com/nauticaalvarez/p/DalQhmcChsx/",
    kind: "image",
  },
  {
    id: "DaU4BQjiobI",
    title: "Artaban 755",
    caption: "Reparación completa terminada y preparada para navegar.",
    src: "/images/social/nauticaalvarez/DaU4BQjiobI.jpg",
    poster: null,
    instagramUrl: "https://www.instagram.com/nauticaalvarez/p/DaU4BQjiobI/",
    kind: "image",
  },
  {
    id: "DZ8OUk1CtOa",
    title: "Beneteau Oceanis 320",
    caption: "Antifouling y protección del casco para volver al Mediterráneo.",
    src: "/images/social/nauticaalvarez/DZ8OUk1CtOa.jpg",
    poster: null,
    instagramUrl: "https://www.instagram.com/nauticaalvarez/p/DZ8OUk1CtOa/",
    kind: "image",
  },
];
